<umkt-auth-layout>
  <div class="auth-back">
    <a routerLink="/">
      <mat-icon>chevron_left</mat-icon>
      {{ 'shared.buttons.back' | i18n }}
    </a>
  </div>
  <div class="auth-card-content">
    <div class="auth-card-form">
      <div class="auth-intern-form">
        <div class="auth-title font-highlight">
          <h1>{{ 'pages.login.title' | i18n }} <span class="auth-title-highlight">{{ 'pages.login.titleHighlight' | i18n }}</span></h1>
        </div>
        
        <p class="auth-desc">{{ 'pages.resetPassword.description' | i18n }}</p>
        
        <div *ngIf="loadingToken" class="loading-container">
          <p>{{ 'pages.resetPassword.loadingToken' | i18n }}</p>
        </div>

        <form *ngIf="!loadingToken && resetForm" [formGroup]="resetForm" class="auth-form" (ngSubmit)="resetPassword()">
          
          <div class="input-group">
            <umkt-custom-input 
              #passwordInput 
              formControlName="password" 
              type="password" 
              [ariaLabel]="'pages.resetPassword.password.label' | i18n"
              [placeholder]="'pages.resetPassword.password.placeholder' | i18n" 
              (passwordToggle)="onPasswordToggle($event)" 
              maxLength="256">
            </umkt-custom-input>
            <div *ngIf="passwordControl?.errors?.['invalidPassword'] && passwordControl?.touched" class="field-error">
              {{ 'pages.resetPassword.password.errorInvalid' | i18n }}
            </div>
          </div>
          
          <div class="input-group">
            <umkt-custom-input 
              #confirmPasswordInput 
              formControlName="confirmPassword" 
              type="password"
              [ariaLabel]="'pages.resetPassword.confirmPassword.label' | i18n" 
              [placeholder]="'pages.resetPassword.confirmPassword.placeholder' | i18n"
              (passwordToggle)="onPasswordToggle($event)" 
              maxLength="256">
            </umkt-custom-input>
            <div *ngIf="confirmPasswordControl?.errors?.['mismatch'] && confirmPasswordControl?.touched"
              class="field-error">
              {{ 'pages.resetPassword.confirmPassword.errorMismatch' | i18n }}
            </div>
          </div>

          <umkt-password-requirements 
            [requirements]="passwordRequirements"
            [isPristine]="isPasswordPristine">
          </umkt-password-requirements>

          <ustore-button [type]="'submit'" [format]="'filled'" [backgroundColor]="'var(--color-red-500-to-yellow)'" [textColor]="'var(--color-inverted)'"
            [size]="'medium'" [rounded]="'default'" [text]="(loadingSubmit ? 'pages.resetPassword.submittingButton' : 'pages.resetPassword.submitButton') | i18n"
            [icon]="{ name: loadingSubmit ? 'hourglass_empty' : 'lock_reset', type: 'material-icons', position: 'left' }"
            [full]="true" 
            [disabled]="resetForm.invalid || loadingSubmit">
          </ustore-button>
        </form>
      </div>
    </div>
  </div>
</umkt-auth-layout>